<template>
  <div id="invomain" class="animated fadeIn absolute top-0 right-0 bottom-0 left-0">
    <div class="center m2">
      <p class="darkblue h4 semi-bold my2 m0 p0">{{partnername}}</p>
      <p class="p0 m0">Hermed liste over kunder der automatisk inviteres til at give din en anbefaling.</p>
      <p class="p0 m0">VIGTIGT: Hvis du ikke ønsker, at sende en invitation, skal du fjerne fluebenet. <br> PS: Vi gemmer automatisk </p>
    </div>
    <div v-if="loading">
      <div class="col-12">
        <div class="loader"></div>
      </div>
    </div>
    <div class="max-width-3 flex flex-column mx-auto justify-start items-center" v-else>
      <div class="flex mx-start p1 darkblue-background white regular h5 invoitem " v-for="(item,index) in pitems" :key="index">
          <b-form-checkbox
            @change="changestatus(item)"
            :id="'checkbox-'+item.GUID"
            :name="'checkbox-'+item.GUID"
            :checked="item.IS_SEND_EMAIL === 1"
            :disabled="disablecheckbox"
            unchecked-value="not_accepted"
            class="gibson darkblue">
          </b-form-checkbox>
          <p class="m0">{{item.NAME}}</p>
      </div>
    </div>
    <div class="max-width-3 flex flex-column mx-auto center justify-start items-center mt4" v-if="shownodata">
        <p class="semi-bold">Ingen registreringer fundet ...</p>
    </div>
    <b-modal  centered v-model="statuschange" hide-header id="statuschange"  ref="statuschange">
    <!-- https://docs.google.com/document/d/1FdsTwi6R7G__OU7-E_hb_kLJYrneiy3krFoIG0xVHHw/edit# -->
          <div class="py1" ></div>
          <slot name="modal-header">
            <div class="col-12 flex justify-end">
              <button type="button" @click="closeconfirmchange()"  class="white-button no-border not-rounded  ">
                <span>
                <i class="pt2 el-icon-circle-close"></i>
                </span>
              </button>
            </div>
          </slot>
          <div class="clearfix white-background ">
            <div class="flex flex-column col-12 p0">
              <p class="my2 darkblue mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="92.104" height="122.269" viewBox="0 0 92.104 122.269">
                  <g id="Group_4292" data-name="Group 4292" transform="translate(-1901.896 -1841.384)">
                    <path id="Path_2691" data-name="Path 2691" d="M2050.619,2063.713,2038,2057.206a.61.61,0,0,0-.2-.2c-.106-.06-10.945-6.476-13.783-15.262a131.483,131.483,0,0,0-8.62-20.592c.785-1.812,5.4-12.47,6.642-15.655,1.9-4.891.106-7.171-.83-7.971,3.533-7.186,3.08-8.831,2.159-9.466a1.467,1.467,0,0,0-1.132-.2c-.015,0-.03.015-.06.015a3.884,3.884,0,0,0-1.132-2.989,3.2,3.2,0,0,0-3.261-.2,3.64,3.64,0,0,0-1,.709,7.469,7.469,0,0,0-3.97-.74c-.528.015-2.144.076-8.711,8.348-2.627,3.306-5.133,6.793-6.114,8.348-.906-.951-1.464-1.555-1.495-1.585a.618.618,0,0,0-.725-.121c-.121.06-2.536,1.344-3.155,3.14a8.657,8.657,0,0,0-1.676-.921,1.091,1.091,0,0,0-1.117.121c-.377.272-.83.921-.709,3.276a3.489,3.489,0,0,0-1.193.06,3.189,3.189,0,0,0-1.374.694c-.121-.936-.272-1.812-.423-2.551-.679-3.216-3.412-4.967-7.5-4.8h-.091a.643.643,0,0,0-.468.211c-.317.362-.423.468,1.072,13.421.287,2.551.574,4.952.755,6.7.438,4.2,3.336,9.616,5.072,12.862a24.986,24.986,0,0,1,1.313,2.627c-.091.694-1.691,4.514-4.74,11.368-.242.528-.393.876-.468,1.072l-12.168,6.793a.654.654,0,0,0-.3.392.6.6,0,0,0,.091.483l14.719,20.788a.64.64,0,0,0,.468.257h.03a.566.566,0,0,0,.453-.211l10.628-12.319a.6.6,0,0,0,0-.785l-.06-.061,1.026-.785c.2.2.393.377.589.574,4.333,4.061,8.952,6.854,12.7,7.669,7.548,1.661,16.742,6.386,16.833,6.431a.594.594,0,0,0,.272.06c.06,0,.106-.015.151-.015l10.19,8.832Zm-29.695-58.65c-.876,2.234-3.412,8.167-5.118,12.122a.189.189,0,0,0-.091-.166c-.166-.106-.332-.2-.5-.3-.2-.121-.393-.242-.6-.362a2.474,2.474,0,0,1-.483-.408,2.742,2.742,0,0,0-.483-.438.2.2,0,1,0-.211.332,2.337,2.337,0,0,1,.408.362,2.626,2.626,0,0,0,.574.483l.589.362c.166.106.332.211.513.317a.218.218,0,0,0,.106.03.244.244,0,0,0,.136-.045c-.438,1-.8,1.857-1.072,2.491a19.218,19.218,0,0,0-2.355-3.321c-.3-.317-.694-.725-1.147-1.208,1.162-1.9,6.22-10.19,9.5-16.636C2021.347,1999.4,2022.4,2001.259,2020.924,2005.063Zm1.57-16c.045-.015.151-.03.181,0,.045.03,1.026.83-2.883,8.6-2.566,5.1-6.386,11.564-8.454,14.991a2.052,2.052,0,0,1-1.087-1.253.205.205,0,1,0-.408.045,2.438,2.438,0,0,0,1.283,1.555c-.347.574-.634,1.042-.845,1.374-1.042-1.1-2.295-2.431-3.623-3.834,4.574-7.775,11.836-18.9,15.081-21.12a.573.573,0,0,0,.2-.136A3.094,3.094,0,0,1,2022.494,1989.061Zm-4.3-3.231q1.427-.521,2.083,0c.679.558.725,1.947.664,2.687-1.359,1-3.91,3.668-8.816,11.036-2.823,4.242-5.374,8.469-6.341,10.084-1.4-1.479-2.838-3-4.151-4.393,5.978-7.654,12.651-15.761,15.413-18.478a.9.9,0,0,0,.226-.136.574.574,0,0,0,.136-.2A3.554,3.554,0,0,1,2018.192,1985.83Zm-13.119,7.926c5.9-7.443,7.518-7.865,7.79-7.88a7.254,7.254,0,0,1,2.989.423c-3.4,3.427-9.8,11.4-13.36,15.912a4.189,4.189,0,0,1-.408-.317,2.976,2.976,0,0,0-.634-.438.212.212,0,0,0-.211.03.187.187,0,0,0-.06.211c.045.151.091.3.151.468a.858.858,0,0,0,.06.181,2.289,2.289,0,0,1-.815-1.072.2.2,0,1,0-.392.03c.045.6,1.027,1.495,1.479,1.691a.136.136,0,0,0,.075.015.244.244,0,0,0,.136-.045.189.189,0,0,0,.06-.2c-.045-.211-.121-.408-.181-.619a.4.4,0,0,0,.091.075c.136.106.272.226.423.332-.574.725-1.057,1.344-1.434,1.827-.71-.755-1.374-1.464-1.963-2.083A99.467,99.467,0,0,1,2005.073,1993.756Zm-9.118,7.2c.347.362.951,1.011,1.736,1.842h0c.181.181.362.392.558.589a2.78,2.78,0,0,1-2.174,2.234q-1.291-1.2-2.355-2.038C1993.735,2002.557,1995.094,2001.485,1995.955,2000.957Zm-5.42,2.053a9.586,9.586,0,0,1,2.023,1.223.581.581,0,0,0,.528.407c.423.332.891.74,1.4,1.193a1.529,1.529,0,0,1-.106.619,2.345,2.345,0,0,1-1.042,1.147l-.015-.015a10.021,10.021,0,0,0-2.974-1.993A5.953,5.953,0,0,1,1990.535,2003.01Zm-2.31,3.5a2.809,2.809,0,0,1,1.389.106h.015a7.859,7.859,0,0,1,2.6,1.6,4.558,4.558,0,0,1-.362,2.853,3.41,3.41,0,0,1-1.963,1.57c-1.359-1.057-2.37-1.842-2.808-2.159,0-.076-.015-.136-.015-.211-.091-.891-.2-1.766-.287-2.612A2.2,2.2,0,0,1,1988.225,2006.512Zm-.951,5.616c.453.347,1.027.785,1.676,1.3a4.787,4.787,0,0,1-1.193,2.476C1987.576,2014.725,1987.425,2013.427,1987.274,2012.128Zm-8.167-12.258a10,10,0,0,1,1.721.136c.242,1.706.845,6.869-.5,8.469a1.609,1.609,0,0,1-.347.3C1979.545,2005,1979.137,2001.168,1979.107,1999.87Zm15.051,61.458-11.911-14.085c.106-.226.242-.543.408-.906,2.31-5.193,3.578-8.137,4.227-9.828.151.468.332.921.5,1.374l.106.272a.215.215,0,0,0,.2.136.137.137,0,0,0,.075-.015.208.208,0,0,0,.121-.257l-.106-.272c-.226-.589-.453-1.208-.649-1.842.151-.423.257-.74.317-.966.151.151.3.317.468.483a3.869,3.869,0,0,0,1.6,1.238c.015,0,.045.015.06.015a.215.215,0,0,0,.2-.136.21.21,0,0,0-.136-.257,3.415,3.415,0,0,1-1.419-1.117,7.37,7.37,0,0,0-.679-.694c0-.453-.377-1.177-1.449-3.185-1.691-3.155-4.514-8.439-4.937-12.409-.181-1.751-.453-4.167-.755-6.718-.106-.936-.226-1.947-.347-2.974a1.6,1.6,0,0,0,.6-.468c1.419-1.691.876-6.748.6-8.635a4.57,4.57,0,0,1,3.729,3.638c.362,1.706.619,4.121.891,6.673.528,4.876,1.011,9.465,2.325,10.99l.091.091a31.6,31.6,0,0,1,9.163,13.1,97.053,97.053,0,0,1,4,17.376l-8.152-8.273a.634.634,0,0,0-.211-.136c-.408-.151-4.046-1.449-5.737.272-1.042,1.057-1.042,2.944.015,5.616a35.774,35.774,0,0,0,7.745,11.187Zm.74-11.141a5.22,5.22,0,0,1-3.518,1.766,2.867,2.867,0,0,1-2.023-1.1c-.317-.634-.619-1.268-.86-1.887-.845-2.144-.951-3.638-.287-4.318.936-.951,3.336-.377,4.318-.03l3.08,3.125A3.758,3.758,0,0,1,1994.9,2050.187Zm1.63,10.145c-.015-.015-.015-.03-.03-.03a.429.429,0,0,0-.151-.136,39.544,39.544,0,0,1-6.476-8.3,2.451,2.451,0,0,0,1.389.528.618.618,0,0,0,.166-.015,5.7,5.7,0,0,0,3.789-1.932,3.966,3.966,0,0,0,.8-2.28l5.842,5.948a.6.6,0,0,0,.6.151c.242.377.453.74.649,1.117.091.181.166.377.257.574a2.84,2.84,0,0,0,.981,1.449.279.279,0,0,0,.106.03.19.19,0,0,0,.166-.091.194.194,0,0,0-.06-.272,2.314,2.314,0,0,1-.815-1.253,3.667,3.667,0,0,0-.272-.6,11.614,11.614,0,0,0-.679-1.163.683.683,0,0,0,.106-.423c0-.015-.015-.121-.045-.332a4.011,4.011,0,0,0,1.147,1.223.279.279,0,0,0,.106.03.174.174,0,0,0,.166-.091.194.194,0,0,0-.06-.272,3.964,3.964,0,0,1-1.072-1.162,6.52,6.52,0,0,0-.408-.559,99.352,99.352,0,0,0-4.151-18.267,32.383,32.383,0,0,0-9.511-13.617,11.165,11.165,0,0,1-1.253-4.2,4.553,4.553,0,0,0,1.479-2.642c4.453,3.517,12.288,10.039,14.3,13.843,2.823,5.359,3.17,8.545,3.17,8.575a.6.6,0,0,0,.6.543h.06a.609.609,0,0,0,.544-.664c-.015-.136-.347-3.427-3.306-9.028-2.1-3.97-9.843-10.462-14.4-14.055a3.7,3.7,0,0,0,1.947-1.676,4.658,4.658,0,0,0,.453-2.627c5.254,4.831,16.727,18.252,17.708,20.229a6.048,6.048,0,0,1,.725,3.4.6.6,0,0,0,.483.71c.045,0,.075.015.121.015a.585.585,0,0,0,.589-.5,7.05,7.05,0,0,0-.83-4.167c-1.132-2.28-12.59-15.564-17.8-20.41a2.606,2.606,0,0,0,1.117-1.3,4.045,4.045,0,0,0,.106-.408c3.276,3.019,8.3,8.56,15.957,18.463a2.615,2.615,0,0,1-.8.574.2.2,0,0,0-.136.257.209.209,0,0,0,.2.151.114.114,0,0,0,.06-.015,2.612,2.612,0,0,0,.951-.649c.181.242.362.468.543.71.332.438.589.755.725.936a.613.613,0,0,0,.966-.755c-.136-.181-.377-.483-.71-.921-6.778-8.816-12.2-15.172-16.2-18.991a3.125,3.125,0,0,0,2.159-2.219c3.925,4.167,10.628,11.277,12.862,13.617a21.308,21.308,0,0,1,2.748,4.046.61.61,0,0,0,.075.136,129.98,129.98,0,0,1,8.62,20.592c2.642,8.182,11.5,14.176,13.8,15.61l-10.507,17.074c-2.053-1.011-9.949-4.816-16.636-6.28C2005.556,2067.653,2000.68,2064.407,1996.528,2060.331Z" transform="translate(-56.619 -121.392)" fill="#19a3c0"/>
                    <path id="Path_2692" data-name="Path 2692" d="M2176.331,2287.492a.2.2,0,0,0-.136-.377,3.274,3.274,0,0,0-1.042.8c-.362.362-.755.725-1.057.74a.2.2,0,0,0-.2.211.2.2,0,0,0,.2.2h.015c.453-.015.891-.438,1.328-.861A3.21,3.21,0,0,1,2176.331,2287.492Z" transform="translate(-230.941 -378.428)" fill="#19a3c0"/>
                    <path id="Path_2693" data-name="Path 2693" d="M2179.4,2292.582a6.457,6.457,0,0,1-1.812,1.3.21.21,0,0,0-.136.257.2.2,0,0,0,.2.136.09.09,0,0,0,.06-.015,7.324,7.324,0,0,0,1.962-1.389.21.21,0,0,0,0-.287A.19.19,0,0,0,2179.4,2292.582Z" transform="translate(-233.954 -383.035)" fill="#19a3c0"/>
                    <path id="Path_2694" data-name="Path 2694" d="M2221.841,2273.778a3.733,3.733,0,0,0-1.434.921.2.2,0,0,0,.271.3c.091-.091.181-.166.272-.242a1.458,1.458,0,0,0-.272.5.229.229,0,0,0,.045.2.194.194,0,0,0,.151.06h.045a2.066,2.066,0,0,0,.906-.513.2.2,0,0,0,.015-.287.206.206,0,0,0-.257-.045,2.361,2.361,0,0,0,.483-.6.21.21,0,0,0-.015-.211A.234.234,0,0,0,2221.841,2273.778Z" transform="translate(-270.368 -367.115)" fill="#19a3c0"/>
                    <path id="Path_2695" data-name="Path 2695" d="M2248.8,2223.215a.2.2,0,0,0-.317-.257c-.347.438-1.268,1.313-1.615,1.344a.2.2,0,0,0-.181.211.2.2,0,0,0,.2.181h.015C2247.476,2224.649,2248.548,2223.532,2248.8,2223.215Z" transform="translate(-292.742 -323.904)" fill="#19a3c0"/>
                    <path id="Path_2696" data-name="Path 2696" d="M2254.658,2226.084a6.774,6.774,0,0,0-.679.619,4.453,4.453,0,0,1-.921.77.217.217,0,0,0-.075.272.208.208,0,0,0,.166.091.279.279,0,0,0,.106-.03,5.385,5.385,0,0,0,1-.83,6.167,6.167,0,0,1,.649-.589.2.2,0,0,0,.03-.287A.226.226,0,0,0,2254.658,2226.084Z" transform="translate(-298.068 -326.591)" fill="#19a3c0"/>
                    <path id="Path_2697" data-name="Path 2697" d="M2149.733,2444.678l.181-.166a.191.191,0,0,0,.015-.272.214.214,0,0,0-.257-.061,4.307,4.307,0,0,0-.845.725l-.287.287a3.361,3.361,0,0,1-1.1.574.2.2,0,0,0-.151.227.194.194,0,0,0,.2.166h.015a1.974,1.974,0,0,0,1.3-.664A9.273,9.273,0,0,0,2149.733,2444.678Z" transform="translate(-208.344 -511.777)" fill="#19a3c0"/>
                    <path id="Path_2698" data-name="Path 2698" d="M2159.032,2452.257a2.59,2.59,0,0,1-1.736.875h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.211.2,2.981,2.981,0,0,0,2.023-1.011.21.21,0,0,0,0-.287A.272.272,0,0,0,2159.032,2452.257Z" transform="translate(-216.677 -518.601)" fill="#19a3c0"/>
                    <path id="Path_2699" data-name="Path 2699" d="M2204.882,2119.6a7.162,7.162,0,0,1-2.778-2.566l-.076-.091a.205.205,0,1,0-.332.241l.075.091a7.585,7.585,0,0,0,2.929,2.687.191.191,0,0,0,.091.015.2.2,0,0,0,.181-.121A.176.176,0,0,0,2204.882,2119.6Z" transform="translate(-254.51 -233.889)" fill="#19a3c0"/>
                    <path id="Path_2700" data-name="Path 2700" d="M2215.895,2123.347c-.075-.045-.136-.106-.211-.151a.205.205,0,0,0-.241.332,2.556,2.556,0,0,0,.211.151,4.854,4.854,0,0,1,.725.574.193.193,0,0,0,.151.06.245.245,0,0,0,.136-.045.21.21,0,0,0,.015-.287A4.807,4.807,0,0,0,2215.895,2123.347Z" transform="translate(-266.142 -239.238)" fill="#19a3c0"/>
                    <path id="Path_2701" data-name="Path 2701" d="M1915.015,2106.408a.6.6,0,0,0,.03-1.208l-12.515-.6a.6.6,0,1,0-.06,1.208l12.515.6Z" transform="translate(0 -223.476)" fill="#19a3c0"/>
                    <path id="Path_2702" data-name="Path 2702" d="M1981.406,2006.613l4.635,3.442a.651.651,0,0,0,.362.121.63.63,0,0,0,.483-.241.616.616,0,0,0-.121-.845l-4.635-3.442a.616.616,0,0,0-.845.121A.589.589,0,0,0,1981.406,2006.613Z" transform="translate(-67.296 -139.366)" fill="#19a3c0"/>
                    <path id="Path_2703" data-name="Path 2703" d="M2070.719,1955.211a.6.6,0,0,0,.543.332.592.592,0,0,0,.272-.06.605.605,0,0,0,.272-.815l-4.484-8.862a.608.608,0,1,0-1.087.543Z" transform="translate(-139.474 -88.372)" fill="#19a3c0"/>
                    <path id="Path_2704" data-name="Path 2704" d="M2170.788,1904h.045a.6.6,0,0,0,.558-.649l-.5-7.609a.59.59,0,0,0-.649-.559.6.6,0,0,0-.559.649l.5,7.609A.6.6,0,0,0,2170.788,1904Z" transform="translate(-227.361 -45.678)" fill="#19a3c0"/>
                    <path id="Path_2705" data-name="Path 2705" d="M2295.645,1854.52h.045a.608.608,0,0,0,.6-.558l.966-11.926a.606.606,0,1,0-1.208-.091l-.966,11.926A.607.607,0,0,0,2295.645,1854.52Z" transform="translate(-333.831)" fill="#19a3c0"/>
                    <path id="Path_2706" data-name="Path 2706" d="M2379.719,1937a.6.6,0,0,0,.423-.181l4.227-4.182a.608.608,0,0,0-.86-.86l-4.227,4.182a.6.6,0,0,0,0,.86A.63.63,0,0,0,2379.719,1937Z" transform="translate(-405.163 -76.597)" fill="#19a3c0"/>
                  </g>
                </svg>
              </p>
              <p class="bold h3 darkblue pt1 mx-auto" >Skift Succes</p>
                <span class="h6 semi-bold my3 center">Hvis du har spørgsmål er du velkommen til at kontakte os.</span>
            </div>
          </div>
          <div slot="modal-footer" class="col-12 m0 p2 darkblue-background flex flex-column items-center justify-center">
            <p class="white" style="font-size:14px;">Alt det bedste</p>
            <div class="flex justify-center items-center ">
              <p class="white">Håndværker.dk</p>
              </div>
          </div>
    </b-modal>
    <b-modal  centered  hide-header id="incorrecturl" :no-close-on-backdrop="true" ref="incorrecturl">
        <div class="py1" ></div>
        <div class="clearfix white-background ">
          <div class="flex flex-column col-12 p0">
            <p class="my2 darkblue mx-auto">
            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </p>
            <p class="bold h3 darkblue pt1 mx-auto" >Tak for besøget</p>
              <p class="h6 darkblue py1 mt2 mx-auto" >Der er noget galt med det link, du modtager</p>
              <span class="h6 semi-bold my3 center">e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager</span>
          </div>
        </div>
        <div class="col-12 flex justify-center items-center py1 mx">
          <a href="https://www.haandvaerker.dk" type="button" class="regular p2 action-button center white"> bekræfte</a>
        </div>
        <div slot="modal-footer" class="col-12 m0 p2 darkblue-background flex flex-column items-center justify-center">
          <p class="white" style="font-size:14px;">Alt det bedste</p>
          <div class="flex justify-center items-center ">
            <span class="mr1">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Craftsmansss" width="36" height="36" alt="Haandvaerker.dk Logo" viewBox="0 0 40 40" class="z2"><defs><linearGradient id="linear-gradientsss" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#0494ba"></stop> <stop offset="1" stop-color="#64c7cb"></stop></linearGradient></defs> <rect id="Rectangle_806sss" data-name="Rectangle 806sss" width="40" height="40" rx="2" transform="translate(0)" fill="url(#linear-gradientsss)"></rect> <path id="Path_1022" data-name="Path 1022" d="M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z" transform="translate(11.082 9.593)" fill="#fff"></path>
              </svg>
            </span>
            <p class="white">Håndværker.dk</p>
            </div>
        </div>
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
export default {
  name: 'Invo',
  components: {
    Simplert
  },
  data: function () {
    return {
      pid: '',
      levid: '',
      pitems: [],
      status: '',
      statuschange: false,
      loading: false,
      statusarr: [],
      disablecheckbox: false,
      shownodata: false,
      stoploading: false,
      partnername: ''
    }
  },
  created () {
    var pathArray = window.location.href.split('/')
    this.pid = pathArray[pathArray.length - 1]
    // this.pid = localStorage.getItem('invocode')
    if (this.pid !== null) {
      this.getinfo(this.pid)
    }
    // window.history.pushState('', '', window.location.href + '/' + this.pid)
  },
  methods: {
    showpopuperror () {
      this.$refs['incorrecturl'].show()
    },
    closepopuperror () {
      this.$refs['incorrecturl'].hide()
    },
    openconfirmchange () {
      this.$refs['statuschange'].show()
    },
    closeconfirmchange () {
      this.$refs['statuschange'].hide()
    },
    decode () {
      this.$http.get(this.$bitrixapi + 'integration/decode/' + this.pid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.data === '') {
            this.showpopuperror()
          }
          if (res.success) {
            this.levid = res.data
            this.getinfo(this.levid)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    changestatus (item) {
      this.stoploading = true
      this.disablecheckbox = true
      var iditem = item.ID
      if (item.IS_SEND_EMAIL === 1) {
        this.status = 0
      } else {
        this.status = 1
      }
      var data = {
        IS_SEND_EMAIL: this.status
      }
      this.$http.post(this.$bitrixapi + 'integration/udpateSupplierIntegrationInformation/' + iditem, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.$message({
              type: 'success',
              message: 'Succes med at ændre status'
            })
          }
          this.getinfo()
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
          this.disablecheckbox = false
          console.log('Error: ', response)
        }
      )
    },
    getinfo () {
      if (!this.stoploading) {
        this.loading = true
      }
      this.$http.get(this.$bitrixapi + 'integration/getSupplierIntegrationInformation/' + this.pid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.pitems = res.data.results
            if (res.data.length < 1) {
              this.shownodata = true
            }
            this.disablecheckbox = false
            this.partnername = res.data.title
            this.loading = false
          } else {
            this.disablecheckbox = false
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>
<style>
#invomain .loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
#invomain .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
#invomain .loader:before,
.loader:after {
  position: absolute;
  content: '';
}
#invomain .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
#invomain .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
#invomain  .field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}
#invomain .custom-control-input {
    position: unset;
    z-index: 1;
    opacity: 1;
    width: 20px;
    height: 18px;
}
@-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
#statuschange .modal-footer {
  padding: 0;
}
#incorrecturl .modal-footer {
  padding: 0;
}
#invomain .custom-control {
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: flex;
    min-height: 0;
    padding-left: 0;
    margin-right: 1rem;
}
#invomain .image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
.invoitem {
  width: 450px;
}
@media (max-width:25em) {
  .invoitem {
    width: 350px;
  }
}
</style>


// WEBPACK FOOTER //
// invo.vue?6fd5df8e